import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useQuery } from 'hooks'
import { DataTable, DataTablePagination } from 'components/common'
import { columns, FOC_FORM_FIELDS } from './utils'
import { SetSelectedColumns } from 'types/dataTable'
import { RowClickedEvent } from '@ag-grid-community/core'
import { PAGE_FOC_ORDER_LIST } from 'utils/constants'
import { fetchFocOrders } from 'utils/api/focApi'

type Props = {
  setSelectedColumns: SetSelectedColumns
  loading: boolean
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
}

const FocOrdersTable = ({ setSelectedColumns, loading, setLoading }: Props) => {
  const [focOrdersData, setFocOrdersData] = useState<any>({})

  const { search } = useLocation()
  const { getAllQueries } = useQuery()
  const navigate = useNavigate()

  const getOrders = async () => {
    setLoading(true)

    const { limit, search: SearchTerm, page, focOrderFilters } = getAllQueries()
    try {
      const { data } = await fetchFocOrders({
        limit: limit || 10,
        page: page || 1,
        search: SearchTerm,
        filters: focOrderFilters,
      })
      setSelectedColumns(data?.tableConfig?.['focOrder'] || [])
      setFocOrdersData({ ...data })
    } catch (error) {
      setFocOrdersData({ docs: [] })
    } finally {
      setLoading(false)
    }
  }

  const onRowClicked = (event: RowClickedEvent) => {
    navigate(
      `${PAGE_FOC_ORDER_LIST.path}/${event.data[FOC_FORM_FIELDS.ORDER_NO.key]}`,
    )
  }

  useEffect(() => {
    getOrders()
  }, [search])

  return (
    <>
      <DataTable
        columns={loading ? [] : columns}
        rows={loading ? null : focOrdersData?.docs}
        identifier={FOC_FORM_FIELDS.ORDER_NO.key}
        onRowClicked={onRowClicked}
        activeColumnsKey="focOrder"
        activeColumns={focOrdersData?.tableConfig?.focOrder || []}
      />

      {/* Pagination */}
      <DataTablePagination
        disableGoToLastPage
        shouldDisplayTotalPages={false}
        currentPage={focOrdersData?.page}
        totalPages={focOrdersData?.totalPages}
        hasNextPage={focOrdersData?.hasNextPage}
        hasPrevPage={focOrdersData?.hasPrevPage}
        limit={focOrdersData?.limit}
        nextPage={focOrdersData?.nextPage}
        prevPage={focOrdersData?.prevPage}
      />
    </>
  )
}

export default FocOrdersTable
